export default __webpack_public_path__ + "static/media/hall2.66c58599.jpeg";